import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sm:flex gap-2 sm:gap-4 mt-4 sm:mt-6" }
const _hoisted_2 = { class: "sm:space-y-4 space-y-2 mx-auto" }
const _hoisted_3 = { class: "w-full sm:mt-0 mt-6" }
const _hoisted_4 = { class: "flex items-center gap-2 ml-auto rounded-md bg-gray-700 px-4 py-2 max-w-fit mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "redirect-label",
  class: "text-white text-ellipsis whitespace-nowrap overflow-hidden"
}, "Redirect Mode", -1)
const _hoisted_6 = { class: "flex gap-2 sm:gap-4 max-w-fit ml-auto" }

import ImageLoading from '@/components/shared/ImageLoading.vue';
import {
	Button,
	Form,
	FormItem,
	Input,
	Select,
	Switch,
	Textarea,
	TreeSelect
} from 'ant-design-vue';
import { capitalize, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { Hentai, HentaiStatus } from '@/model/hentai';
import { CopyOutlined } from '@ant-design/icons-vue';
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue';
import LocalStorageKey from '@/model/key';
import { scrapingHentai } from '@/util/scraping';


export default /*#__PURE__*/_defineComponent({
  __name: 'HentaiInformation',
  props: {
    isLoading: { type: Boolean },
    hentai: {},
    hentaiStatuses: {},
    onSubmit: { type: Function }
  },
  setup(__props: any) {

const props = __props;



const store = useStore();

const imageURL = ref('');
const isValidLink = ref(false);
const isRedirect = ref(localStorage.getItem(LocalStorageKey.HentaiRedirect) === 'on');
const hentai = ref<Hentai>({ ...props.hentai });
const loading = ref(props.isLoading);

watch(
	() => props.isLoading,
	(load) => (loading.value = load)
);
watch(() => props.hentai, initialize);
watch(isRedirect, () =>
	localStorage.setItem(LocalStorageKey.HentaiRedirect, isRedirect.value ? 'on' : 'off')
);

function mapSelect(texts: string[]) {
	return texts.map((text) => {
		return {
			value: text,
			title: text,
			label: capitalize(text),
			key: text
		};
	});
}

async function scraping() {
	if (!hentai.value.link || props.isLoading || loading.value) {
		return;
	}
	loading.value = true;
	try {
		const result = await scrapingHentai(hentai.value.link);
		hentai.value = { ...hentai.value, ...result };
		imageURL.value = result.coverImageURL;
		isValidLink.value = true;
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		loading.value = false;
	}
}

async function submit() {
	if (props.isLoading || !isValidLink.value) {
		return;
	}
	if (hentai.value) {
		await props.onSubmit({ ...hentai.value }, isRedirect.value);
		if (!isRedirect.value) {
			initialize();
		}
	}
}

function initialize() {
	hentai.value = { ...props.hentai };
	imageURL.value = props.hentai.coverImageURL;
	isValidLink.value = !!props.hentai.hentaiUUID;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SpinnerLoading, { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ImageLoading, {
            src: imageURL.value,
            previewable: true,
            "img-class": "!h-72 !w-72",
            "loading-class": "h-72 w-72 m-auto sm:m-0"
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Form), {
            layout: "horizontal",
            model: hentai.value,
            onFinish: _cache[9] || (_cache[9] = ($event: any) => (submit()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FormItem), {
                label: "Link",
                name: "link",
                "has-feedback": "",
                rules: [{ required: true, message: `Please enter hentai cover image url` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input).Group, { compact: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Input), {
                        value: hentai.value.link,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((hentai.value.link) = $event)),
                        class: "!w-[calc(100%-2rem)] !text-start",
                        placeholder: `Enter a hentai cover image url`,
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (isValidLink.value = false))
                      }, null, 8, ["value"]),
                      _createVNode(_unref(Button), { onClick: scraping }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(CopyOutlined))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Title",
                name: "title",
                "has-feedback": "",
                rules: [{ required: true, message: `Please enter hentai title` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input), {
                    value: hentai.value.title,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((hentai.value.title) = $event)),
                    placeholder: `Enter a hentai title`,
                    disabled: !!hentai.value.hentaiUUID,
                    class: "bg-white"
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Studio",
                name: "studio",
                "has-feedback": "",
                rules: [{ required: true, message: `Please enter hentai studio` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Input), {
                    value: hentai.value.studio,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((hentai.value.studio) = $event)),
                    placeholder: `Enter a hentai studio`,
                    class: "bg-white"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Category",
                name: "categories",
                "has-feedback": "",
                rules: [{ required: true, message: `Please select hentai category` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TreeSelect), {
                    value: hentai.value.categories,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((hentai.value.categories) = $event)),
                    style: {"width":"100%"},
                    "tree-data": mapSelect(hentai.value.categories),
                    "tree-checkable": "",
                    class: "text-start bg-white rounded-md",
                    placeholder: `Please select hentai category`,
                    "tree-node-filter-prop": "label",
                    disabled: ""
                  }, null, 8, ["value", "tree-data"])
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Status",
                name: "status",
                "has-feedback": "",
                rules: [{ required: true, message: `Please select hentai status` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Select), {
                    value: hentai.value.status,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((hentai.value.status) = $event)),
                    options: mapSelect(_ctx.hentaiStatuses),
                    placeholder: `Please select hentai status`,
                    class: "text-start"
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              _createVNode(_unref(FormItem), {
                label: "Description",
                name: "description",
                rules: [{ required: true, message: `Please enter hentai description` }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Textarea), {
                    value: hentai.value.description,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((hentai.value.description) = $event)),
                    placeholder: `Enter a hentai description`,
                    autoSize: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_unref(Switch), {
                  checked: isRedirect.value,
                  "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((isRedirect).value = $event))
                }, null, 8, ["checked"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Button), {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (initialize()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Reset")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  "html-type": "submit",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})